// extracted by mini-css-extract-plugin
export default {"pageContainer":"Favourites_pageContainer__GCcwR"};